/* eslint-disable default-case,no-param-reassign,@typescript-eslint/no-redeclare,no-underscore-dangle,@typescript-eslint/no-unused-vars,no-var,vars-on-top */

import { EVENTS } from '../../../../app/constants/events';
import { COMPONENT_TYPE } from '../../../../app/constants/component_type';

xplenty.directive('schemaImporterDataPreview', [
  '$timeout',
  '$translate',
  function ($timeout, $translate) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./schema-importer-data-preview.html'),

      scope: {
        data: '=',
        component: '=',
        options: '=?',
        refreshData: '&?',
        isComponentPreviewer: '=?',
        isPreviewLoading: '=?',
      },

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$rootScope',
        function ($scope, $rootScope) {
          $scope.type = 'raw';
          $scope.dataPreviewError = null;
          $scope.dataPreviewDisabled = true;

          $scope.previewTypes = {
            table: {
              id: 'table',
              name: 'Table',
              selected: false,
              active: false,
            },
            json: {
              id: 'json',
              name: 'JSON',
              selected: false,
              active: false,
            },
            raw: {
              id: 'raw',
              name: 'RAW',
              selected: false,
              active: false,
            },
          };

          $scope.selectPreviewType = function (currentPreviewType) {
            _.each($scope.previewTypes, function (previewType) {
              previewType.selected = false;
            });
            currentPreviewType.selected = true;
            $scope.type = currentPreviewType.id;
          };

          $scope.fields = [];
          $scope.items = [];
          $scope.json = [];

          $scope.previewTypes.table.active = false;
          $scope.previewTypes.json.active = false;
          $scope.previewTypes.raw.active = false;

          $scope.loading = false;

          $scope.refreshDataLoading = function () {
            $scope.dataPreviewError = null;
            $scope.loading = true;
            $scope.refreshData();
          };

          $scope.removeDataPreviewError = function () {
            $scope.dataPreviewError = null;
          };

          let fieldsObject = {};

          const clear = function () {
            $scope.fields = [];
            $scope.items = [];
            $scope.json = [];
            $scope.raw = '';
          };

          const setFields = function (fields) {
            const _fields = [];
            fieldsObject = {};
            _.each(fields, function (field) {
              const fieldName = Object.keys(field)[0];
              fieldsObject[fieldName] = field[fieldName];
              _fields.push({
                name: fieldName,
                alias: fieldName,
                data_type: field[fieldName],
              });
            });
            $scope.fields = _fields;
          };

          const setItems = function (items) {
            const _items = [];
            _.each(items, function (item, index) {
              if (index > 99) return;
              var item = {
                values: item,
              };
              _items.push(item);
            });
            $scope.items = _items;
          };

          const setRaw = function (raw) {
            let _json = [];
            let _raw = '';
            let { data } = $scope;

            if (typeof $scope.data === 'string') {
              data = JSON.parse($scope.data);
            }

            if ($scope.isComponentPreviewer && data && data.raw && !data.fields) {
              _raw = raw;
              try {
                _json = JSON.parse(raw);
              } catch (e) {
                _json = {};
                if (raw.includes('},{')) {
                  _raw = raw
                    .split(',')
                    .map((rawItem) => `${rawItem}\n`)
                    .join();
                }
              }
            } else if ($scope.component.record_delimiter === 'eof' && $scope.component.record_type === 'json') {
              _.each(raw, function (rawItem) {
                _raw = rawItem;
                try {
                  _json = JSON.parse(rawItem);
                } catch (e) {
                  _json = {};
                }
              });
            } else {
              _.each(raw, function (rawItem) {
                _raw += `${rawItem}\n`;
                let _jsonRaw;
                try {
                  _jsonRaw = JSON.parse(rawItem);
                } catch (e) {
                  _jsonRaw = {};
                }
                _json.push(_jsonRaw);
              });
            }
            $scope.raw = _raw;
            $scope.json = _json;
          };

          const setJson = function (data) {
            const _json = {};
            _.each(data.fields, function (field, index) {
              const key = Object.keys(field)[0];
              if (data.data && data.data[0] && data.data[0][index]) {
                _json[key] = data.data[0][index];
              } else {
                _json[key] = '';
              }
            });
            $scope.json = _json;
          };

          const buildJson = function (data) {
            clear();
            if (data && data.raw) {
              setRaw(data.raw);
              return;
            }
            if (data && data.data) {
              setJson(data);
            }
          };

          const initData = function (data) {
            if (typeof data === 'string') {
              data = JSON.parse(data);
            }

            if ($scope.isComponentPreviewer && data && data.raw && !data.fields) {
              $scope.previewTypes.table.active = false;
              $scope.previewTypes.json.active = false;
              $scope.previewTypes.raw.active = true;
              $scope.selectPreviewType($scope.previewTypes.raw);
            }

            if (
              $scope.component.componentType === COMPONENT_TYPE.REST_API_SOURCE_COMPONENT &&
              $scope.component.response_type !== 'line_delimited_data' &&
              !$scope.isComponentPreviewer
            ) {
              if ($scope.component.response_type === 'raw') {
                // if raw response is bigger than 5MB than throw an error
                if (data && data.data && data.data[0] && data.data[0][1] && data.data[0][1].length > 1024 * 1024 * 5) {
                  $rootScope.$broadcast(
                    EVENTS.DATA_PREVIEW_ERROR,
                    $translate.instant('data-preview.errors.response_too_big'),
                  );
                  return;
                }
              }
              buildJson(data);
              return;
            }

            if (data) {
              if (data.fields) {
                setFields(data.fields);
                setItems(data.data);
              }
              if (data.data.length === 0 && data.raw) {
                $scope.selectPreviewType($scope.previewTypes.raw);
                setRaw(data.raw);
              }
              if (data.raw) setRaw(data.raw);
              $scope.dataPreviewError = null;
            } else {
              clear();
            }
          };

          const initView = function (component) {
            switch (component.componentType) {
              case COMPONENT_TYPE.CLOUD_STORAGE_SOURCE_COMPONENT:
                if (component.record_delimiter === 'new_line' && component.record_type === 'delimited') {
                  $scope.previewTypes.table.active = true;
                  $scope.previewTypes.json.active = false;
                  $scope.previewTypes.raw.active = true;
                  $scope.selectPreviewType($scope.previewTypes.table);
                }

                if (component.record_delimiter === 'new_line' && component.record_type === 'json') {
                  $scope.previewTypes.table.active = false;
                  $scope.previewTypes.json.active = true;
                  $scope.previewTypes.raw.active = true;
                  $scope.selectPreviewType($scope.previewTypes.json);
                }

                if (component.record_delimiter === 'new_line' && component.record_type === 'raw') {
                  $scope.previewTypes.table.active = false;
                  $scope.previewTypes.json.active = false;
                  $scope.previewTypes.raw.active = true;
                  $scope.selectPreviewType($scope.previewTypes.raw);
                }

                if (component.record_delimiter === 'eof' && component.record_type === 'json') {
                  $scope.previewTypes.table.active = false;
                  $scope.previewTypes.json.active = true;
                  $scope.previewTypes.raw.active = true;
                  $scope.selectPreviewType($scope.previewTypes.json);
                }

                if (component.record_delimiter === 'eof' && component.record_type === 'raw') {
                  $scope.previewTypes.table.active = false;
                  $scope.previewTypes.json.active = false;
                  $scope.previewTypes.raw.active = true;
                  $scope.selectPreviewType($scope.previewTypes.raw);
                }
                break;

              case COMPONENT_TYPE.DATABASE_SOURCE_COMPONENT:
                $scope.previewTypes.table.active = false;
                $scope.selectPreviewType($scope.previewTypes.table);
                break;

              case COMPONENT_TYPE.REST_API_SOURCE_COMPONENT:
                if (component.response_type === 'line_delimited_data' || $scope.isComponentPreviewer) {
                  $scope.selectPreviewType($scope.previewTypes.table);
                } else {
                  $scope.selectPreviewType($scope.previewTypes.json);
                }

                break;

              case COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT:
                $scope.selectPreviewType($scope.previewTypes.table);
                break;

              case COMPONENT_TYPE.EXECUTE_SQL_COMPONENT:
                if (component.connection.type === 'bigquery') {
                  $scope.selectPreviewType($scope.previewTypes.raw);
                } else {
                  $scope.selectPreviewType($scope.previewTypes.table);
                }
                break;
              case COMPONENT_TYPE.AMAZON_REDSHIFT_SOURCE_COMPONENT:
              case COMPONENT_TYPE.NET_SUITE_SOURCE_COMPONENT:
              case COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT:
              case COMPONENT_TYPE.ANALYTICS_GA4_SOURCE_COMPONENT:
              case COMPONENT_TYPE.SALESFORCE_SOURCE_COMPONENT:
              case COMPONENT_TYPE.SPANNER_SOURCE_COMPONENT:
                $scope.selectPreviewType($scope.previewTypes.table);
                break;
            }
          };

          $scope.$watch('component', initView, true);

          $scope.$watch('data', initData);

          $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADED, function (event, data) {
            $scope.loading = false;
            initData(data);
          });

          $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED, function () {
            $scope.loading = true;
          });

          $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED, function () {
            $scope.loading = false;
          });

          $scope.$on(EVENTS.DATA_PREVIEW_ERROR, function (event, error) {
            $scope.dataPreviewError = _.escape(error);
            $scope.fields = [];
            $scope.items = [];
            $scope.loading = false;
          });

          $scope.$on(EVENTS.DATA_PREVIEW_DISABLED, function (event, dataPreviewDisabled) {
            $scope.dataPreviewDisabled = dataPreviewDisabled;
          });
        },
      ],
    };
  },
]);
